import React, { useState } from "react";
import { Box, Button, Grid } from "@mui/material";
import MicIcon from "@mui/icons-material/Mic";
import IconButton from "@mui/material/IconButton";
import StopCircleIcon from "@mui/icons-material/StopCircle";
import DeleteIcon from "@mui/icons-material/Delete";
import TextField from "@mui/material/TextField";
import { v4 as uuidv4 } from "uuid";
import { withSnackbar } from "notistack";

import MicRecorder from "mic-recorder-to-mp3";

const AUDIO_RECORDER = new MicRecorder({ bitRate: 128 });

const AudioRecorderPlayer = ({
  audioFileList,
  studyRecordingsList,
  handleAddAudioFileToList,
  handleRemoveAudioFileFromList,
  Status,
  enqueueSnackbar,
}) => {
  const [isRecording, setIsRecording] = useState(false);

  const handleMarkAsRecording = () => setIsRecording(true);
  const handleMarkAsNotRecording = () => setIsRecording(false);
  const startRecording = async () => {
    try {
      handleMarkAsRecording();
      const _ = await AUDIO_RECORDER.start();
    } catch (err) {
      handleMarkAsNotRecording();
      enqueueSnackbar(`ERROR : ${err.message}`, {
        preventDuplicate: true,
        variant: "error",
      });
      console.log("err", err.message);
    }
  };

  const stopRecording = async () => {
    try {
      const [_, blob] = await AUDIO_RECORDER.stop().getMp3();
      const blobUrl = URL.createObjectURL(blob);
      const date = new Date();
      const file = new File([blob], date.valueOf(), { type: "audio/wav" });
      const audioFile = {
        id: uuidv4(),
        blobUrl,
        file,
      };

      handleAddAudioFileToList(audioFile);
      handleMarkAsNotRecording();
    } catch (err) {
      handleMarkAsNotRecording();
      enqueueSnackbar(`ERROR : ${err.message}`, {
        preventDuplicate: true,
        variant: "error",
      });
      console.log("err", err.message);
    }
  };

  return (
    <>
      {Status == "DICTATE" && ( 
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                pl: 1,
                pb: 1,
                mt: 1,
                mb: 1,
              }}
            >
              <Button
                sx={{
                  position: "relative",
                  borderRadius: "10px",
                  maxWidth: "unset",
                  background: "#333333",
                  paddingRight: isRecording ? "8px" : "20px !important",
                  mr: 1,
                }}
                color="secondary"
                title={isRecording ? "Click to start recording" : null}
                onClick={() => !isRecording && startRecording()}
              >
                <IconButton
                  sx={{
                    position: "relative",
                    zIndex: 5,
                    mr: !isRecording ? 1 : 0,
                  }}
                >
                  {isRecording && (
                    <Box
                      sx={{
                        height: "51px",
                        width: "51px",
                        borderRadius: "50%",
                        position: "absolute",
                        top: 0,
                        left: 0,
                        zIndex: 0,
                        background: "#f44335",
                      }}
                      className="animate__animated animate__fadeIn animate__slow animate__infinite"
                    />
                  )}
                  <MicIcon
                    sx={{
                      height: 35,
                      width: 35,
                      position: "relative",
                      zIndex: 5,
                    }}
                  />
                </IconButton>

                {!isRecording && (
                  <Box
                    sx={{
                      height: "100%",
                      flex: 1,
                      color: "#fff",
                    }}
                  >
                    Click to start recording
                  </Box>
                )}
              </Button>

              <Button
                sx={{
                  position: "relative",
                  borderRadius: "10px",
                  maxWidth: "unset",
                  background: "#333333",
                }}
                color="secondary"
                disabled={!isRecording}
                title={isRecording ? "Click to stop recording" : null}
                onClick={stopRecording}
              >
                <IconButton
                  sx={{
                    position: "relative",
                    zIndex: 5,
                    mr: isRecording ? 1 : 0,
                  }}
                >
                  <StopCircleIcon
                    sx={{
                      height: 35,
                      width: 35,
                      position: "relative",
                      zIndex: 5,
                    }}
                  />
                </IconButton>

                {isRecording && (
                  <Box
                    sx={{
                      height: "100%",
                      flex: 1,
                      color: "#fff",
                      paddingRight: "15px !important",
                    }}
                  >
                    Click to stop recording
                  </Box>
                )}
              </Button>
            </Box>
          </Grid>
        </Grid>
      )} 

      <br />

      <Grid container spacing={2}>
        {studyRecordingsList.length
          ? studyRecordingsList.map((url, i) => {
              return (
                <Grid item xs={6} key={uuidv4()}>
                  <Box
                    sx={{
                      display: "flex",
                      gap: 1,
                      alignItems: "center",
                      pl: 1,
                      pb: 1,
                    }}
                  >
                    <TextField
                      label="Number"
                      variant="filled"
                      disabled={true}
                      value={i + 1}
                      style={{ width: "72px !important" }}
                    />

                    <audio id="audio" controls src={url ? url : audioFileList[i].file.blobUrl ?audioFileList[i].file.blobUrl:null } />
                  </Box>
                </Grid>
              );
            })
          : audioFileList.map((file, i) => {
              return (
                <Grid item xs={6} key={uuidv4()}>
                  <Box
                    sx={{
                      display: "flex",
                      gap: 1,
                      alignItems: "center",
                      pl: 1,
                      pb: 1,
                    }}
                  >
                    <IconButton
                      color="primary"
                      onClick={() => handleRemoveAudioFileFromList(file.id)}
                    >
                      <DeleteIcon />
                    </IconButton>

                    <TextField
                      label="Number"
                      variant="filled"
                      disabled={true}
                      value={i + 1}
                      style={{ width: "72px !important" }}
                    />

                    <audio
                      id="audio"
                      controls
                      src={file.blobUrl ? file.blobUrl :studyRecordingsList[i] ? studyRecordingsList[i]: null}
                    />
                  </Box>
                </Grid>
              );
            })}
      </Grid>
      <br />
    </>
  );
};

export default withSnackbar(AudioRecorderPlayer);
